import { Component, Input, OnInit } from "@angular/core";
import {
  faCalendarDay,
  faCheckSquare,
  faFile,
  faHistory,
  faLink,
  faList,
  faText,
  faTextSize,
  faUser,
  faUserTie,
  faHashtag,
  faQuestion,
} from "@fortawesome/pro-regular-svg-icons";
import {
  IconDefinition,
  faUserGroup,
  faUser as dynUser,
} from "@fortawesome/pro-duotone-svg-icons";

const DataPointTypeIcons: {
  [key: string]: IconDefinition;
} = {
  auto_inc: faHashtag,
  choice: faCheckSquare,
  created: faHistory,
  date: faCalendarDay,
  document: faFile,
  editor: faTextSize,
  employee: faUserTie,
  file: faFile,
  hyperlink: faLink,
  label: faText,
  ofac: faText,
  owned_by: faUser,
  select: faList,
  select_multiple: faList,
  text: faText,
  number: faHashtag,
  textarea: faTextSize,
  updated: faHistory,
  group: faUserGroup,
  user: dynUser,
};

@Component({
    selector: "app-datapoint-icons",
    templateUrl: "./datapoint-icons.component.html",
    styleUrls: ["./datapoint-icons.component.scss"],
    standalone: false
})
export class DatapointIconsComponent implements OnInit {
  @Input() icon!: any;
  @Input() type!: any;

  ngOnInit(): void {}

  /**
   * Returns the appropriate icon for dataPointType
   * @param type
   * @return IconDefinition | default: faQuestion
   */
  getDataPointTypeIcon(type: string): IconDefinition {
    return DataPointTypeIcons[type] ?? faQuestion;
  }
}
